import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CartSummary = ({ subtotal, tax, total, itemCount, onCheckout, disabled }) => {
  return (
    <div className="bg-card rounded-xl p-6 sticky top-24">
      <h3 className="font-heading font-bold text-foreground text-xl mb-6">
        Order Summary
      </h3>

      {/* Summary Details */}
      <div className="space-y-4 mb-6">
        <div className="flex items-center justify-between text-foreground">
          <span>Subtotal ({itemCount} {itemCount === 1 ? 'item' : 'items'})</span>
          <span className="font-medium">${subtotal?.toFixed(2)}</span>
        </div>

        <div className="flex items-center justify-between text-foreground">
          <span>Tax (13.5%)</span>
          <span className="font-medium">${tax?.toFixed(2)}</span>
        </div>

        <div className="border-t border-border pt-4">
          <div className="flex items-center justify-between text-foreground">
            <span className="font-heading font-bold text-lg">Total</span>
            <span className="font-heading font-bold text-lg text-primary">
              ${total?.toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      {/* Checkout Button */}
      <Button
        onClick={onCheckout}
        disabled={disabled}
        className="w-full flex items-center justify-center gap-2"
      >
        <Icon name="ShoppingBag" size={18} />
        Proceed to Checkout
      </Button>

      {/* Additional Info */}
      <div className="mt-6 space-y-3">
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <Icon name="Truck" size={18} className="flex-shrink-0 mt-0.5" />
          <p>Delivery fees calculated at checkout</p>
        </div>
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <Icon name="Shield" size={18} className="flex-shrink-0 mt-0.5" />
          <p>Secure checkout with multiple payment options</p>
        </div>
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <Icon name="Clock" size={18} className="flex-shrink-0 mt-0.5" />
          <p>Schedule delivery at your convenience</p>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;